import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiArrowLeft, FiHome } from 'react-icons/fi';

const NoPermission = ({ 
  title = "Access Denied", 
  message = "You don't have permission to access this page.",
  showBackButton = true,
  showHomeButton = true 
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 200px)',
      padding: '3rem 2rem',
      textAlign: 'center',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      borderRadius: '12px',
      margin: '2rem',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      border: '1px solid #e2e8f0'
    }}>
      {/* Icon */}
      <div style={{
        fontSize: '5rem',
        marginBottom: '1.5rem',
        color: '#ef4444',
        opacity: '0.9'
      }}>
        <FiShield />
      </div>

      {/* Title */}
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: '700',
        marginBottom: '1rem',
        color: '#1e293b',
        textShadow: 'none'
      }}>
        {title}
      </h1>

      {/* Message */}
      <p style={{
        fontSize: '1.1rem',
        marginBottom: '2.5rem',
        maxWidth: '600px',
        lineHeight: '1.7',
        color: '#64748b',
        fontWeight: '500'
      }}>
        {message}
      </p>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: '2rem'
      }}>
        {showBackButton && (
          <button
            onClick={() => window.history.back()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.875rem 1.75rem',
              fontSize: '1rem',
              fontWeight: '600',
              border: '2px solid #e2e8f0',
              borderRadius: '8px',
              background: '#ffffff',
              color: '#64748b',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f8fafc';
              e.target.style.borderColor = '#cbd5e1';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#ffffff';
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          >
            <FiArrowLeft />
            Go Back
          </button>
        )}

        {showHomeButton && (
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.875rem 1.75rem',
              fontSize: '1rem',
              fontWeight: '600',
              border: '2px solid #3b82f6',
              borderRadius: '8px',
              background: '#3b82f6',
              color: 'white',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 4px rgba(59,130,246,0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#2563eb';
              e.target.style.borderColor = '#2563eb';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 8px rgba(59,130,246,0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#3b82f6';
              e.target.style.borderColor = '#3b82f6';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(59,130,246,0.3)';
            }}
          >
            <FiHome />
            Go Home
          </Link>
        )}
      </div>

      {/* Additional Info */}
      <div style={{
        padding: '1.5rem',
        background: '#f1f5f9',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        maxWidth: '500px'
      }}>
        <p style={{
          fontSize: '0.9rem',
          color: '#64748b',
          margin: '0',
          lineHeight: '1.5'
        }}>
          If you believe you should have access to this page, please contact your administrator.
        </p>
      </div>
    </div>
  );
};

export default NoPermission; 